import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import {
	ForgeUIEmbeddedMacroAnalyticsContext,
	type EmbeddedMacroParentType,
	type EmbeddedMacroType,
} from './ForgeUIEmbeddedMacroAnalyticsContext';
import { useMetricsContext } from '../context/metrics';
import { trackEmbeddedMacroRendered } from './useForgeUiAnalyticsEvent';

type EmbeddedNonForgeMacroWithAnalyticsProps = {
	children: React.ReactNode;
	contentId?: string;
	embeddedMacroParentType?: EmbeddedMacroParentType;
	embeddedMacroType?: EmbeddedMacroType;
	extensionKey?: string;
	source?: string;
};

type EmbeddedMacroRenderedAnalyticsTriggerProps = {
	extensionKey?: string;
	source?: string;
};

const EmbeddedMacroRenderedAnalyticsTrigger = ({
	extensionKey,
	source,
}: EmbeddedMacroRenderedAnalyticsTriggerProps): null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { page } = useMetricsContext();
	const analyticsSource = source ?? page;

	useEffect(() => {
		trackEmbeddedMacroRendered(createAnalyticsEvent, {
			source: analyticsSource,
			extensionKey,
		});
	}, [analyticsSource, createAnalyticsEvent, extensionKey]);

	return null;
};

export const EmbeddedNonForgeMacroWithAnalytics = ({
	children,
	contentId,
	embeddedMacroParentType = 'UIKit',
	embeddedMacroType = 'productMacroCore',
	extensionKey,
	source,
}: EmbeddedNonForgeMacroWithAnalyticsProps): React.JSX.Element => {
	return (
		<ForgeUIEmbeddedMacroAnalyticsContext
			contentId={contentId}
			embeddedMacroParentType={embeddedMacroParentType}
			embeddedMacroType={embeddedMacroType}
		>
			<EmbeddedMacroRenderedAnalyticsTrigger extensionKey={extensionKey} source={source} />
			{children}
		</ForgeUIEmbeddedMacroAnalyticsContext>
	);
};
